var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("v-slide-y-transition", [
    _vm.showBanner
      ? _c(
          "div",
          {
            staticClass: "status-banner",
            class: { "status-banner--mobile": _vm.$vuetify.breakpoint.xs },
            style: _vm.bannerStyle,
          },
          [
            _c(
              "v-icon",
              { staticClass: "banner-icon", attrs: { color: "white" } },
              [_vm._v(_vm._s(_vm.bannerIcon))]
            ),
            _vm.countdownText
              ? _c("span", { staticClass: "countdown-badge" }, [
                  _vm._v(_vm._s(_vm.countdownText)),
                ])
              : _vm._e(),
            _c("span", { staticClass: "banner-text" }, [
              _vm._v(_vm._s(_vm.status.bannerText)),
            ]),
            _vm.status.dismissable
              ? _c(
                  "v-btn",
                  {
                    staticClass: "dismiss-btn",
                    attrs: { icon: "", small: "", color: "white" },
                    on: {
                      click: function ($event) {
                        _vm.dismissed = true
                      },
                    },
                  },
                  [
                    _c("v-icon", { attrs: { small: "" } }, [
                      _vm._v("mdi-close"),
                    ]),
                  ],
                  1
                )
              : _vm._e(),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }